// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface SessionWarningDialogProps {
  open: boolean;
  handleContinue: () => void;
  appSignOut: () => void;
}

function SessionWarningDialog(props: SessionWarningDialogProps) {
  const { open, handleContinue, appSignOut } = props;
  return (
    <Dialog
      open={open}
      onClose={handleContinue}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Are you still there?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          It looks like you've been inactive for a while. Would you like to
          continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleContinue}>Continue</Button>
        <Button onClick={() => appSignOut()}>Logout</Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionWarningDialog;
